// Additional services data - Copyright (continued), Patent, and Company Formation

export const additionalServicesData = {
  // COPYRIGHT SERVICES (continued)
  'copyright-litigation': {
    title: 'Copyright Litigation',
    category: 'Copyright Services',
    tagline: 'Defend or pursue copyright infringement claims',
    description: 'Experienced copyright litigation attorneys for federal court cases',
    buttonText: 'Start Litigation',
    hero: {
      title: 'Copyright Litigation Services',
      subtitle: 'Aggressive representation in federal copyright infringement lawsuits'
    },
    what: {
      title: 'What is Copyright Litigation?',
      content: [
        'Copyright litigation is the process of resolving copyright disputes through federal court proceedings. This includes filing infringement lawsuits to stop unauthorized use and recover damages, as well as defending against infringement claims. Federal court is the exclusive venue for copyright cases, requiring specialized knowledge of copyright law and federal procedure.',
        'Our copyright litigators have extensive experience in federal courts nationwide. We handle all aspects of copyright litigation from complaint drafting through trial and appeal. Whether pursuing infringers or defending against baseless claims, we provide strategic, cost-effective representation focused on achieving the best possible outcome.'
      ],
      quote: 'Experienced copyright litigation counsel levels the playing field and maximizes your chances of success in federal court.'
    },
    benefits: [
      { icon: 'Scale', title: 'Federal Court Experience', desc: 'Seasoned litigators with proven track record in federal copyright cases nationwide.' },
      { icon: 'Target', title: 'Strategic Litigation', desc: 'Cost-effective strategies balancing litigation expense with potential recovery or defense savings.' },
      { icon: 'Shield', title: 'Strong Defense', desc: 'Vigorous defense against baseless infringement claims including fair use arguments.' },
      { icon: 'DollarSign', title: 'Maximum Recovery', desc: 'Pursue statutory damages, actual damages, profits, and attorney fees from infringers.' },
      { icon: 'FileText', title: 'Discovery Management', desc: 'Expert handling of complex discovery including digital forensics and expert witnesses.' },
      { icon: 'Award', title: 'Trial Ready', desc: 'Experienced trial attorneys prepared to take your case through verdict if necessary.' },
      { icon: 'Clock', title: 'Preliminary Relief', desc: 'Seek temporary restraining orders and preliminary injunctions for immediate protection.' },
      { icon: 'Globe', title: 'Appellate Expertise', desc: 'Handle appeals to Circuit Courts and Supreme Court when case law development is important.' }
    ],
    pricing: [
      {
        name: 'Case Evaluation',
        price: '$999',
        description: 'Litigation assessment',
        features: [
          'Comprehensive Case Review',
          'Litigation Risk Analysis',
          'Cost-Benefit Evaluation',
          'Strategic Recommendations',
          'Settlement Potential Assessment'
        ]
      },
      {
        name: 'Limited Scope',
        price: '$5,000+',
        description: 'Specific litigation tasks',
        popular: true,
        features: [
          'Complaint Drafting',
          'Motion Practice',
          'Discovery Management',
          'Settlement Negotiation',
          'Hourly or Flat Fee Options'
        ]
      },
      {
        name: 'Full Representation',
        price: 'Custom',
        description: 'Complete litigation support',
        features: [
          'End-to-End Representation',
          'All Court Appearances',
          'Discovery & Depositions',
          'Expert Witnesses',
          'Trial Preparation & Trial',
          'Contingency Options Available'
        ]
      }
    ],
    process: [
      {
        title: 'Case Assessment',
        description: 'Evaluate merits, analyze likelihood of success, estimate costs and potential recovery, recommend litigation strategy.'
      },
      {
        title: 'Pleadings & Discovery',
        description: 'File complaint or answer, conduct document discovery, take depositions, retain expert witnesses as needed.'
      },
      {
        title: 'Resolution',
        description: 'Negotiate settlement, prepare for and conduct trial, pursue post-trial motions and appeals if necessary.'
      }
    ]
  },

  'copyright-portfolio': {
    title: 'Copyright Portfolio Management',
    category: 'Copyright Services',
    tagline: 'Manage and protect your copyright assets',
    description: 'Comprehensive copyright portfolio management and strategic optimization',
    buttonText: 'Manage Portfolio',
    hero: {
      title: 'Copyright Portfolio Management',
      subtitle: 'Strategic administration of your complete copyright portfolio'
    },
    what: {
      title: 'What is Copyright Portfolio Management?',
      content: [
        'Copyright portfolio management is the systematic administration of all your copyrighted works including tracking registrations, monitoring usage, managing licenses, and ensuring ongoing protection. As creative businesses grow, managing individual copyrights becomes complex and time-consuming. Portfolio management provides centralized oversight and strategic administration.',
        'Our service maintains comprehensive records of all your copyrights, tracks registration status, monitors license compliance, coordinates enforcement activities, and provides strategic guidance on portfolio optimization. We ensure your creative assets remain protected and properly monetized while reducing administrative burden.'
      ],
      quote: 'Professional portfolio management transforms copyright assets from administrative headaches into strategic business advantages.'
    },
    benefits: [
      { icon: 'FileText', title: 'Centralized Records', desc: 'Comprehensive database of all registered and unregistered copyrights with supporting documentation.' },
      { icon: 'Calendar', title: 'Registration Tracking', desc: 'Monitor application status, renewal requirements, and recordation of transfers.' },
      { icon: 'DollarSign', title: 'License Management', desc: 'Track active licenses, ensure compliance, monitor payment obligations, and identify new opportunities.' },
      { icon: 'Shield', title: 'Infringement Monitoring', desc: 'Ongoing surveillance for unauthorized use with coordinated enforcement response.' },
      { icon: 'Target', title: 'Strategic Optimization', desc: 'Regular portfolio audits to identify gaps, redundancies, and monetization opportunities.' },
      { icon: 'Globe', title: 'International Coordination', desc: 'Manage copyrights across multiple countries with coordinated registration strategy.' },
      { icon: 'Award', title: 'Valuation Support', desc: 'Portfolio valuation analysis for transactions, financing, or financial reporting.' },
      { icon: 'Lock', title: 'Secure Portal', desc: 'Online access to complete copyright records, licenses, and portfolio reports.' }
    ],
    pricing: [
      {
        name: 'Small Portfolio',
        price: '$499/year',
        description: 'Up to 20 copyrights',
        features: [
          'Registration Tracking',
          'Renewal Management',
          'License Database',
          'Annual Review',
          'Email Support'
        ]
      },
      {
        name: 'Growing Portfolio',
        price: '$1,299/year',
        description: 'Up to 100 copyrights',
        popular: true,
        features: [
          'Everything in Small',
          'Quarterly Reviews',
          'Infringement Monitoring',
          'License Compliance Tracking',
          'Strategic Recommendations',
          'Priority Support'
        ]
      },
      {
        name: 'Enterprise',
        price: 'Custom',
        description: 'Unlimited copyrights',
        features: [
          'Everything in Growing',
          'Unlimited Works',
          'Monthly Reviews',
          'International Management',
          'Valuation Services',
          'Dedicated Manager'
        ]
      }
    ],
    process: [
      {
        title: 'Portfolio Audit',
        description: 'Comprehensive inventory of all copyrights, identify unregistered works, establish baseline portfolio status.'
      },
      {
        title: 'Ongoing Administration',
        description: 'Monitor registrations, track licenses, coordinate enforcement, maintain comprehensive records and documentation.'
      },
      {
        title: 'Strategic Management',
        description: 'Regular portfolio reviews, optimization recommendations, identify monetization opportunities, align with business strategy.'
      }
    ]
  },

  'copyright-dmca': {
    title: 'Digital Millennium Copyright Act',
    category: 'Copyright Services',
    tagline: 'DMCA takedown notices and compliance',
    description: 'Expert DMCA services including takedowns, counter-notices, and compliance',
    buttonText: 'File DMCA',
    hero: {
      title: 'DMCA Services',
      subtitle: 'Digital Millennium Copyright Act takedowns and safe harbor compliance'
    },
    what: {
      title: 'What are DMCA Services?',
      content: [
        'The Digital Millennium Copyright Act (DMCA) provides a streamlined process for removing infringing content from websites and online platforms. Copyright owners can send takedown notices to service providers, who must remove the content to maintain safe harbor protection. DMCA services also include responding to takedown notices with counter-notices when content is wrongly identified as infringing.',
        'Our DMCA practice handles both sides of takedown notices. For copyright owners, we prepare and file notices to remove infringing content from websites, social media, and online marketplaces. For platform operators, we provide safe harbor compliance programs and respond to notices. For content creators, we file counter-notices to restore wrongly removed content.'
      ],
      quote: 'DMCA takedown notices provide fast, cost-effective removal of online infringement without costly litigation.'
    },
    benefits: [
      { icon: 'Clock', title: 'Fast Removal', desc: 'Expedited removal of infringing content from websites and platforms within days.' },
      { icon: 'FileText', title: 'Proper Notices', desc: 'Attorney-prepared notices meeting all DMCA statutory requirements for enforceability.' },
      { icon: 'Globe', title: 'Multi-Platform', desc: 'File takedown notices across all major platforms including Google, YouTube, Facebook, Amazon.' },
      { icon: 'Shield', title: 'Safe Harbor Protection', desc: 'Help service providers implement DMCA compliance programs to maintain safe harbor.' },
      { icon: 'Target', title: 'Counter-Notice Defense', desc: 'Respond to improper takedown notices with effective counter-notices to restore content.' },
      { icon: 'Scale', title: 'Legal Compliance', desc: 'Ensure all notices comply with 17 U.S.C. § 512 requirements for legal validity.' },
      { icon: 'Lock', title: 'Perjury Protection', desc: 'Accurate notice preparation to avoid false takedown liability under penalty of perjury.' },
      { icon: 'Award', title: 'Repeat Infringer Policies', desc: 'Implement repeat infringer policies required for safe harbor protection.' }
    ],
    pricing: [
      {
        name: 'Single Takedown',
        price: '$299',
        description: 'One DMCA notice',
        features: [
          'DMCA Notice Preparation',
          'Platform Filing',
          'Single Infringement',
          'Follow-Up Monitoring',
          '14-Day Support'
        ]
      },
      {
        name: 'Multi-Platform Package',
        price: '$799',
        description: 'Multiple takedowns',
        popular: true,
        features: [
          'Everything in Single',
          'Up to 10 Notices',
          'Multiple Platforms',
          'Batch Filing',
          'Extended Monitoring',
          '30-Day Support'
        ]
      },
      {
        name: 'Safe Harbor Compliance',
        price: '$2,499',
        description: 'Platform protection program',
        features: [
          'DMCA Agent Registration',
          'Policy Development',
          'Notice Response Procedures',
          'Repeat Infringer System',
          'Staff Training',
          'Ongoing Compliance'
        ]
      }
    ],
    process: [
      {
        title: 'Infringement Identification',
        description: 'Identify infringing content, document locations and URLs, gather evidence of infringement and your copyright ownership.'
      },
      {
        title: 'Notice Preparation',
        description: 'Prepare DMCA-compliant takedown notice with required elements, identify correct service provider agent, file notice.'
      },
      {
        title: 'Follow-Up & Enforcement',
        description: 'Monitor for content removal, respond to counter-notices if filed, pursue litigation if content not removed or restored.'
      }
    ]
  },

  // PATENT SERVICES
  'patent-searches': {
    title: 'Patent Searches',
    category: 'Patent Services',
    tagline: 'Comprehensive prior art and patentability searches',
    description: 'Professional patent searches to assess novelty and patentability',
    buttonText: 'Search Patents',
    hero: {
      title: 'Patent Search Services',
      subtitle: 'Comprehensive prior art searches to evaluate patentability of your invention'
    },
    what: {
      title: 'What is a Patent Search?',
      content: [
        'A patent search is a comprehensive investigation of prior art to determine if your invention is novel and non-obvious compared to existing technology. This includes searching issued patents, published applications, technical literature, and products in the marketplace. A thorough search identifies potential obstacles to patentability before investing in expensive patent applications.',
        'Our patent searches are conducted by experienced patent professionals who understand both the technical aspects of your invention and the legal standards for patentability. We provide detailed search reports with analysis of relevant prior art, assessment of patentability prospects, and strategic recommendations for patent protection.'
      ],
      quote: 'A comprehensive patent search is the foundation of any successful patent strategy, identifying risks and opportunities early.'
    },
    benefits: [
      { icon: 'Target', title: 'Patentability Assessment', desc: 'Evaluate whether your invention meets novelty and non-obviousness requirements for patent protection.' },
      { icon: 'DollarSign', title: 'Cost Savings', desc: 'Avoid wasted application costs by identifying patentability issues before filing.' },
      { icon: 'FileText', title: 'Detailed Report', desc: 'Comprehensive search report with cited prior art, claim charts, and patentability analysis.' },
      { icon: 'Globe', title: 'Worldwide Coverage', desc: 'Search international patent databases, foreign applications, and non-patent literature.' },
      { icon: 'Award', title: 'Claim Strategy', desc: 'Identify how to differentiate your claims from prior art for strongest possible protection.' },
      { icon: 'Shield', title: 'Freedom to Operate', desc: 'Optional freedom-to-operate searches to identify patents that could block your commercialization.' },
      { icon: 'Clock', title: 'Fast Turnaround', desc: 'Receive search results and analysis within 5-10 business days.' },
      { icon: 'Scale', title: 'Expert Analysis', desc: 'Technical and legal analysis by patent professionals with relevant technical backgrounds.' }
    ],
    pricing: [
      {
        name: 'Preliminary Search',
        price: '$799',
        description: 'Quick patentability check',
        features: [
          'USPTO Database Search',
          'U.S. Patents & Applications',
          'Basic Prior Art Report',
          'Patentability Opinion',
          '5-Day Turnaround'
        ]
      },
      {
        name: 'Comprehensive Search',
        price: '$1,999',
        description: 'Thorough prior art analysis',
        popular: true,
        features: [
          'Everything in Preliminary',
          'International Patents',
          'Non-Patent Literature',
          'Detailed Claim Analysis',
          'Strategic Recommendations',
          'Patent Attorney Review'
        ]
      },
      {
        name: 'FTO + Patentability',
        price: '$3,999',
        description: 'Complete IP clearance',
        features: [
          'Everything in Comprehensive',
          'Freedom-to-Operate Search',
          'Infringement Risk Analysis',
          'Design-Around Options',
          'Licensing Opportunities',
          'Strategic Consultation'
        ]
      }
    ],
    process: [
      {
        title: 'Invention Disclosure',
        description: 'Understand your invention, key features, technical field, and intended commercial applications to focus search.'
      },
      {
        title: 'Comprehensive Search',
        description: 'Search patent databases, technical literature, and relevant sources. Analyze results for relevance to your invention.'
      },
      {
        title: 'Report & Strategy',
        description: 'Deliver detailed search report with prior art analysis, patentability assessment, and strategic filing recommendations.'
      }
    ]
  },

  'patent-office-actions': {
    title: 'Patent Office Actions & Amendments',
    category: 'Patent Services',
    tagline: 'Respond to USPTO patent examination issues',
    description: 'Expert handling of patent office actions and examiner rejections',
    buttonText: 'Respond Now',
    hero: {
      title: 'Patent Office Action Response',
      subtitle: 'Strategic responses to USPTO rejections and requirements'
    },
    what: {
      title: 'What are Patent Office Actions?',
      content: [
        'A patent office action is an official communication from a USPTO patent examiner raising objections or rejections to your patent application. Common issues include prior art rejections (35 U.S.C. § 102 and 103), enablement or written description problems, and claim definiteness issues. Responding effectively requires technical expertise, patent law knowledge, and strategic thinking.',
        'Our patent attorneys have extensive experience responding to office actions across all technical fields. We analyze examiner positions, research case law, develop persuasive arguments, and prepare claim amendments when strategic. Our goal is to overcome rejections while securing the broadest possible patent protection for your invention.'
      ],
      quote: 'Strategic office action responses are the difference between patent issuance and application abandonment.'
    },
    benefits: [
      { icon: 'Scale', title: 'Attorney Expertise', desc: 'Registered patent attorneys with technical degrees and deep knowledge of patent examination practice.' },
      { icon: 'Target', title: 'Strategic Analysis', desc: 'Comprehensive evaluation of rejections with multiple response strategies considered.' },
      { icon: 'Award', title: 'Claim Optimization', desc: 'Balance breadth of protection with patentability to achieve strongest possible claims.' },
      { icon: 'FileText', title: 'Technical Arguments', desc: 'Detailed technical and legal arguments addressing every examiner position point-by-point.' },
      { icon: 'CheckCircle2', title: 'High Allowance Rate', desc: 'Proven track record of overcoming rejections and securing patent issuance.' },
      { icon: 'Phone', title: 'Examiner Interviews', desc: 'Conduct productive examiner interviews to clarify issues and reach agreement.' },
      { icon: 'Clock', title: 'Timely Response', desc: 'Responses prepared and filed well before USPTO deadlines to avoid abandonment.' },
      { icon: 'Globe', title: 'Continuation Strategy', desc: 'Advise on continuation applications, divisionals, and RCE strategy when appropriate.' }
    ],
    pricing: [
      {
        name: 'Simple Response',
        price: '$1,499',
        description: 'Minor amendments',
        features: [
          'Attorney Review',
          'Response Preparation',
          'Minor Claim Amendments',
          'Technical Arguments',
          'USPTO Filing'
        ]
      },
      {
        name: 'Complex Response',
        price: '$2,999',
        description: 'Prior art rejections',
        popular: true,
        features: [
          'Everything in Simple',
          'Prior Art Analysis',
          'Case Law Research',
          '102/103 Arguments',
          'Examiner Interview',
          'Multiple Amendments'
        ]
      },
      {
        name: 'Appeal Brief',
        price: '$5,999',
        description: 'PTAB appeal',
        features: [
          'Everything in Complex',
          'Appeal Brief Preparation',
          'PTAB Filing',
          'Appellate Arguments',
          'Examiner\'s Answer Response',
          'Oral Argument Option'
        ]
      }
    ],
    process: [
      {
        title: 'Rejection Analysis',
        description: 'Comprehensive review of office action, analyze cited prior art, research relevant case law, develop response strategy.'
      },
      {
        title: 'Response Preparation',
        description: 'Draft response with technical and legal arguments, prepare claim amendments if strategic, coordinate examiner interview.'
      },
      {
        title: 'Filing & Follow-Up',
        description: 'File response with USPTO, participate in examiner interview, address any additional requirements, track to allowance or appeal.'
      }
    ]
  },

  'patent-applications': {
    title: 'Patent Applications',
    category: 'Patent Services',
    tagline: 'Prepare and file utility, design, or provisional patents',
    description: 'Professional patent application preparation and filing services',
    buttonText: 'File Patent',
    hero: {
      title: 'Patent Application Services',
      subtitle: 'Expert preparation of utility, design, and provisional patent applications'
    },
    what: {
      title: 'What is a Patent Application?',
      content: [
        'A patent application is a detailed technical and legal document filed with the USPTO to seek patent protection for an invention. Utility patents protect functional inventions, design patents protect ornamental designs, and provisional applications establish early filing dates. Patent applications must meet strict requirements for specification, claims, and drawings.',
        'Our patent attorneys combine technical expertise with legal skill to prepare applications that maximize your patent protection. We work with you to fully understand your invention, identify key innovative features, draft comprehensive specifications with multiple claim sets, and prepare professional patent drawings meeting USPTO standards.'
      ],
      quote: 'A well-prepared patent application is the foundation for strong, enforceable patent rights that protect your innovations.'
    },
    benefits: [
      { icon: 'Award', title: 'Technical Expertise', desc: 'Patent attorneys with advanced technical degrees in engineering, computer science, biology, chemistry.' },
      { icon: 'FileText', title: 'Comprehensive Specification', desc: 'Detailed disclosure with multiple embodiments and thorough description of invention.' },
      { icon: 'Target', title: 'Strategic Claims', desc: 'Multiple claim sets with varying breadth to maximize protection and overcome prior art.' },
      { icon: 'Shield', title: 'Professional Drawings', desc: 'High-quality patent drawings prepared by technical illustrators meeting USPTO requirements.' },
      { icon: 'Globe', title: 'International Strategy', desc: 'Coordinate PCT applications and foreign filing for global patent protection.' },
      { icon: 'CheckCircle2', title: 'Prosecution Support', desc: 'Continued support through examination including office action responses.' },
      { icon: 'Clock', title: 'Priority Filing', desc: 'Fast-track preparation and filing to establish early priority dates.' },
      { icon: 'DollarSign', title: 'Cost-Effective Options', desc: 'Provisional applications for budget-conscious inventors to establish filing dates.' }
    ],
    pricing: [
      {
        name: 'Provisional Application',
        price: '$2,499',
        description: 'Establish early filing date',
        features: [
          'Patent Attorney Drafting',
          'Detailed Description',
          'Informal Drawings',
          'USPTO Filing',
          '1-Year Protection',
          'Conversion Support'
        ]
      },
      {
        name: 'Utility Patent',
        price: '$7,999',
        description: 'Full utility patent application',
        popular: true,
        features: [
          'Everything in Provisional',
          'Multiple Claim Sets',
          'Professional Drawings',
          'Prior Art Search Included',
          'Prosecution Support',
          '20-Year Protection'
        ]
      },
      {
        name: 'Design Patent',
        price: '$2,999',
        description: 'Ornamental design protection',
        features: [
          'Design Patent Drafting',
          'Professional Design Drawings',
          'Multiple Views',
          'USPTO Filing',
          '15-Year Protection',
          'Prosecution Included'
        ]
      }
    ],
    process: [
      {
        title: 'Invention Disclosure',
        description: 'Comprehensive invention disclosure meeting, understand technical details, identify key features, discuss prior art.'
      },
      {
        title: 'Application Drafting',
        description: 'Prepare patent specification, draft multiple claim sets, create professional drawings, conduct internal review.'
      },
      {
        title: 'Filing & Prosecution',
        description: 'File application with USPTO, monitor examination, respond to office actions, pursue allowance and issuance.'
      }
    ]
  },

  'patent-enforcement': {
    title: 'Patent Enforcement',
    category: 'Patent Services',
    tagline: 'Protect your patents from infringement',
    description: 'Aggressive patent enforcement through licensing and litigation',
    buttonText: 'Enforce Patent',
    hero: {
      title: 'Patent Enforcement Services',
      subtitle: 'Protect your patent rights and stop unauthorized use of your inventions'
    },
    what: {
      title: 'What is Patent Enforcement?',
      content: [
        'Patent enforcement involves taking action against parties who make, use, sell, or import your patented invention without permission. This includes sending cease and desist letters, negotiating license agreements, filing patent infringement lawsuits, and seeking injunctions and damages. Effective enforcement protects your competitive advantage and generates licensing revenue.',
        'Our patent litigation team has extensive experience in federal district courts and the International Trade Commission. We handle enforcement matters ranging from licensing negotiations through complex patent litigation and appeals. Our strategic approach focuses on achieving favorable resolutions efficiently while maximizing your patent value.'
      ],
      quote: 'Strong patent enforcement protects your innovations, deters competitors, and monetizes your patent portfolio.'
    },
    benefits: [
      { icon: 'Shield', title: 'Stop Infringement', desc: 'Cease and desist letters, preliminary injunctions, and permanent injunctions to stop unauthorized use.' },
      { icon: 'DollarSign', title: 'Damages Recovery', desc: 'Pursue reasonable royalties, lost profits, and enhanced damages for willful infringement.' },
      { icon: 'Scale', title: 'Litigation Expertise', desc: 'Experienced patent litigators with track record in federal district courts nationwide.' },
      { icon: 'Globe', title: 'ITC Investigations', desc: 'File Section 337 investigations at International Trade Commission to block imports.' },
      { icon: 'FileText', title: 'License Negotiations', desc: 'Convert infringers to licensees through strategic licensing negotiations.' },
      { icon: 'Target', title: 'Strategic Enforcement', desc: 'Cost-benefit analysis and strategic planning to maximize ROI on enforcement actions.' },
      { icon: 'Award', title: 'Validity Defense', desc: 'Defend patent validity in PTAB proceedings including IPR, PGR, and reexamination.' },
      { icon: 'Clock', title: 'Fast Action', desc: 'Preliminary injunction motions for immediate relief in urgent infringement situations.' }
    ],
    pricing: [
      {
        name: 'Demand Letter',
        price: '$2,499',
        description: 'Cease and desist',
        features: [
          'Infringement Analysis',
          'Patent Attorney Letter',
          'Claim Chart Preparation',
          'Negotiation Support',
          'License Term Sheet'
        ]
      },
      {
        name: 'Licensing Program',
        price: '$7,999+',
        description: 'Multi-party licensing',
        popular: true,
        features: [
          'Everything in Demand',
          'Multiple Targets',
          'License Agreement Drafting',
          'Extended Negotiation',
          'Portfolio Licensing',
          'Litigation Threat'
        ]
      },
      {
        name: 'Litigation',
        price: 'Custom',
        description: 'Federal court enforcement',
        features: [
          'Everything in Licensing',
          'Federal Court Filing',
          'Preliminary Injunction',
          'Discovery & Trial',
          'Expert Witnesses',
          'Full Litigation Support',
          'Contingency Options'
        ]
      }
    ],
    process: [
      {
        title: 'Infringement Assessment',
        description: 'Analyze alleged infringement, prepare claim charts, assess damages potential, develop enforcement strategy.'
      },
      {
        title: 'Demand & Negotiation',
        description: 'Send demand letter with claim charts, negotiate license terms, draft licensing agreements if resolution reached.'
      },
      {
        title: 'Litigation if Needed',
        description: 'File infringement complaint in federal court, seek preliminary injunction, conduct discovery, pursue trial or settlement.'
      }
    ]
  },

  // COMPANY FORMATION
  'company-llc': {
    title: 'LLC Formation',
    category: 'Company Formation',
    tagline: 'Limited liability protection with flexible management',
    description: 'Professional LLC formation services with complete compliance',
    buttonText: 'Form LLC',
    hero: {
      title: 'LLC Formation Services',
      subtitle: 'Start your Limited Liability Company with proper legal structure and protection'
    },
    what: {
      title: 'What is an LLC?',
      content: [
        'A Limited Liability Company (LLC) is a business structure that combines the liability protection of a corporation with the tax flexibility and operational simplicity of a partnership. LLC owners (called members) are protected from personal liability for business debts and obligations, while enjoying pass-through taxation and minimal compliance requirements.',
        'LLCs are ideal for small businesses, startups, and professional service providers. They offer flexible management structures, simplified tax reporting, and strong personal asset protection. Our LLC formation service handles all filing requirements, drafts operating agreements, and ensures your company starts with proper legal foundation.'
      ],
      quote: 'An LLC provides the perfect balance of liability protection, tax flexibility, and operational simplicity for growing businesses.'
    },
    benefits: [
      { icon: 'Shield', title: 'Liability Protection', desc: 'Protect personal assets from business debts, lawsuits, and obligations.' },
      { icon: 'DollarSign', title: 'Tax Flexibility', desc: 'Pass-through taxation avoids double taxation while allowing S-corp or C-corp election.' },
      { icon: 'FileText', title: 'Operating Agreement', desc: 'Comprehensive operating agreement defining ownership, management, and profit distribution.' },
      { icon: 'Award', title: 'Professional Credibility', desc: 'Establish legitimacy and credibility with customers, vendors, and partners.' },
      { icon: 'Target', title: 'Management Flexibility', desc: 'Choose member-managed or manager-managed structure based on your needs.' },
      { icon: 'Globe', title: 'Multi-State Registration', desc: 'Register in multiple states for interstate business operations.' },
      { icon: 'CheckCircle2', title: 'EIN Acquisition', desc: 'Obtain federal Employer Identification Number for banking and tax purposes.' },
      { icon: 'Clock', title: 'Fast Formation', desc: 'Complete formation and receive approved documents within 5-10 business days.' }
    ],
    pricing: [
      {
        name: 'Basic LLC',
        price: '$499',
        description: 'Essential LLC formation',
        features: [
          'Articles of Organization',
          'State Filing',
          'EIN Application',
          'Basic Operating Agreement',
          'Membership Certificates'
        ]
      },
      {
        name: 'Complete LLC',
        price: '$999',
        description: 'Full LLC package',
        popular: true,
        features: [
          'Everything in Basic',
          'Custom Operating Agreement',
          'Initial Resolutions',
          'Registered Agent Service (1 Year)',
          'Compliance Calendar',
          'Attorney Review'
        ]
      },
      {
        name: 'Multi-State LLC',
        price: '$1,999',
        description: 'Multiple state registration',
        features: [
          'Everything in Complete',
          'Foreign Qualification',
          'Up to 3 Additional States',
          'Multi-State Compliance',
          'Registered Agent (All States)',
          'Ongoing Support'
        ]
      }
    ],
    process: [
      {
        title: 'Company Setup',
        description: 'Choose company name, verify availability, select registered agent, determine ownership structure.'
      },
      {
        title: 'Document Preparation',
        description: 'Prepare and file Articles of Organization, draft operating agreement, obtain EIN, issue membership certificates.'
      },
      {
        title: 'Compliance & Support',
        description: 'Set up compliance calendar, provide ongoing registered agent service, assist with annual filings and requirements.'
      }
    ]
  },

  'company-c-corp': {
    title: 'C Corporation Formation',
    category: 'Company Formation',
    tagline: 'Traditional corporate structure for scalable growth',
    description: 'Professional C Corporation formation for venture-backed and growth companies',
    buttonText: 'Form C-Corp',
    hero: {
      title: 'C Corporation Formation',
      subtitle: 'Establish a C Corporation structure for investor funding and scalable growth'
    },
    what: {
      title: 'What is a C Corporation?',
      content: [
        'A C Corporation is the traditional corporate structure offering limited liability protection, perpetual existence, and unlimited growth potential through stock issuance. C Corps are the preferred structure for venture capital funding, planning to go public (IPO), or building substantial value for acquisition. They provide strong personal liability protection and sophisticated equity compensation options.',
        'C Corporations are taxed as separate entities, with profits taxed at the corporate level and dividends taxed to shareholders (double taxation). However, benefits include unlimited shareholders, multiple stock classes, employee stock options, and 1202 qualified small business stock exclusion. Our formation service establishes proper corporate governance, prepares bylaws, and ensures compliance.'
      ],
      quote: 'C Corporations provide the scalable structure and credibility needed for venture capital funding and significant business growth.'
    },
    benefits: [
      { icon: 'Target', title: 'Investor Ready', desc: 'Preferred structure for venture capital, angel investors, and institutional funding.' },
      { icon: 'Globe', title: 'Unlimited Growth', desc: 'No restrictions on number of shareholders or ownership structure complexity.' },
      { icon: 'Award', title: 'Stock Options', desc: 'Issue employee stock options and other equity compensation for talent acquisition.' },
      { icon: 'Shield', title: 'Liability Protection', desc: 'Strong personal liability protection for shareholders, directors, and officers.' },
      { icon: 'FileText', title: 'Formal Structure', desc: 'Professional corporate governance with board of directors and officer roles.' },
      { icon: 'DollarSign', title: 'Tax Benefits', desc: 'Potential for Section 1202 qualified small business stock tax exclusion (up to $10M gain exemption).' },
      { icon: 'CheckCircle2', title: 'Perpetual Existence', desc: 'Corporation continues regardless of ownership changes or shareholder death.' },
      { icon: 'Lock', title: 'IPO Capable', desc: 'Structure compatible with eventual public offering on stock exchanges.' }
    ],
    pricing: [
      {
        name: 'Basic C Corp',
        price: '$999',
        description: 'Essential corporation formation',
        features: [
          'Articles of Incorporation',
          'State Filing',
          'Standard Bylaws',
          'EIN Application',
          'Initial Stock Issuance'
        ]
      },
      {
        name: 'Investor-Ready Corp',
        price: '$2,499',
        description: 'VC-ready corporate structure',
        popular: true,
        features: [
          'Everything in Basic',
          'Custom Bylaws',
          'Board Resolutions',
          'Stock Purchase Agreements',
          '83(b) Election Support',
          'Capitalization Table',
          'Registered Agent (1 Year)'
        ]
      },
      {
        name: 'Delaware C Corp',
        price: '$3,499',
        description: 'Delaware incorporation',
        features: [
          'Everything in Investor-Ready',
          'Delaware Incorporation',
          'Founder Stock Documents',
          'Vesting Agreements',
          'Board Advisory',
          'Ongoing Compliance',
          'Attorney Consultation'
        ]
      }
    ],
    process: [
      {
        title: 'Corporate Setup',
        description: 'Choose jurisdiction (Delaware vs. home state), select corporate name, determine initial stock structure and ownership.'
      },
      {
        title: 'Incorporation',
        description: 'File Articles of Incorporation, adopt bylaws, hold organizational meeting, issue initial stock, file 83(b) elections.'
      },
      {
        title: 'Governance & Compliance',
        description: 'Establish board of directors, appoint officers, maintain corporate records, assist with annual requirements and filings.'
      }
    ]
  },

  'company-s-corp': {
    title: 'S Corporation Formation',
    category: 'Company Formation',
    tagline: 'Tax advantages for small business owners',
    description: 'S Corporation election for pass-through taxation with corporate benefits',
    buttonText: 'Form S-Corp',
    hero: {
      title: 'S Corporation Formation',
      subtitle: 'Reduce self-employment taxes with S Corporation election'
    },
    what: {
      title: 'What is an S Corporation?',
      content: [
        'An S Corporation is a tax election that allows corporations and LLCs to pass income, losses, deductions, and credits through to shareholders for federal tax purposes, avoiding double taxation. S Corp shareholders report income on personal returns, while the business entity avoids corporate-level tax. This structure is ideal for profitable small businesses looking to reduce self-employment taxes.',
        'S Corps provide liability protection similar to C Corporations while eliminating double taxation. Shareholders who work in the business can be employees, receiving reasonable salaries subject to payroll taxes, while additional profits pass through as distributions not subject to self-employment tax. This creates significant tax savings for profitable small businesses.'
      ],
      quote: 'S Corporation election can save thousands in self-employment taxes while maintaining liability protection and corporate benefits.'
    },
    benefits: [
      { icon: 'DollarSign', title: 'Tax Savings', desc: 'Avoid self-employment taxes on business profits beyond reasonable salary (15.3% savings).' },
      { icon: 'Shield', title: 'Liability Protection', desc: 'Personal asset protection from business debts and legal obligations.' },
      { icon: 'Target', title: 'Pass-Through Taxation', desc: 'Avoid double taxation with income passing directly to shareholder personal returns.' },
      { icon: 'Award', title: 'Professional Image', desc: 'Corporate structure provides credibility with clients, vendors, and lenders.' },
      { icon: 'FileText', title: 'IRS Compliance', desc: 'Proper Form 2553 filing and payroll setup to meet IRS S Corp requirements.' },
      { icon: 'CheckCircle2', title: 'Reasonable Compensation', desc: 'Guidance on setting appropriate shareholder salaries to satisfy IRS requirements.' },
      { icon: 'Clock', title: 'Timely Election', desc: 'Meet strict IRS deadlines for S Corp election to ensure tax benefits.' },
      { icon: 'Lock', title: 'Audit Support', desc: 'Proper documentation and structure to support S Corp status under IRS scrutiny.' }
    ],
    pricing: [
      {
        name: 'S Corp Election',
        price: '$799',
        description: 'Add S Corp to existing entity',
        features: [
          'Form 2553 Preparation',
          'IRS Filing',
          'Deadline Compliance',
          'Shareholder Consents',
          'Filing Confirmation'
        ]
      },
      {
        name: 'S Corp Formation',
        price: '$1,499',
        description: 'New corporation with S election',
        popular: true,
        features: [
          'Everything in Election',
          'Articles of Incorporation',
          'Bylaws & Resolutions',
          'EIN Application',
          'Stock Issuance',
          'S Corp Setup Guide'
        ]
      },
      {
        name: 'Complete Package',
        price: '$2,299',
        description: 'Formation with full compliance',
        features: [
          'Everything in Formation',
          'Payroll Setup Guidance',
          'Reasonable Comp Analysis',
          'Quarterly Tax Planning',
          'Annual Compliance Support',
          'Registered Agent (1 Year)'
        ]
      }
    ],
    process: [
      {
        title: 'Eligibility Review',
        description: 'Verify S Corp eligibility (U.S. shareholders, single class of stock), assess tax savings potential, determine timing of election.'
      },
      {
        title: 'Formation & Election',
        description: 'Form corporation or LLC, file Form 2553 with IRS within deadline, obtain shareholder consents, set up payroll.'
      },
      {
        title: 'Ongoing Compliance',
        description: 'Maintain reasonable compensation requirements, file annual returns, assist with quarterly estimated taxes and compliance.'
      }
    ]
  },

  'company-non-profit': {
    title: 'Non-Profit Organization Formation',
    category: 'Company Formation',
    tagline: 'Tax-exempt status for charitable organizations',
    description: 'Comprehensive non-profit formation including 501(c)(3) tax exemption',
    buttonText: 'Form Nonprofit',
    hero: {
      title: 'Non-Profit Organization Formation',
      subtitle: 'Establish your charitable organization with federal and state tax-exempt status'
    },
    what: {
      title: 'What is a Non-Profit Organization?',
      content: [
        'A non-profit organization is a legal entity organized for charitable, educational, religious, scientific, or other public benefit purposes. Non-profits can qualify for federal 501(c)(3) tax-exempt status, allowing them to receive tax-deductible donations, avoid federal income tax, and qualify for grants. Proper formation requires specific charter language, governance structures, and IRS application.',
        'Our non-profit formation service guides you through the complete process from state incorporation through IRS 501(c)(3) application. We ensure your articles of incorporation meet IRS requirements, establish proper governance policies, prepare Form 1023 or 1023-EZ, and secure both federal and state tax exemptions.'
      ],
      quote: 'Proper non-profit formation with 501(c)(3) status unlocks donor funding, grants, and tax benefits for your charitable mission.'
    },
    benefits: [
      { icon: 'Award', title: 'Tax-Exempt Status', desc: 'Federal 501(c)(3) exemption from income taxes on charitable activities and contributions.' },
      { icon: 'DollarSign', title: 'Tax-Deductible Donations', desc: 'Donors can deduct contributions on their personal tax returns, encouraging larger gifts.' },
      { icon: 'Target', title: 'Grant Eligibility', desc: 'Qualify for foundation grants and government funding requiring 501(c)(3) status.' },
      { icon: 'Shield', title: 'Liability Protection', desc: 'Protect board members and officers from personal liability for organizational actions.' },
      { icon: 'FileText', title: 'IRS Application', desc: 'Expert preparation of Form 1023 or 1023-EZ for favorable IRS determination.' },
      { icon: 'Globe', title: 'State Exemptions', desc: 'Obtain state-level tax exemptions, charitable solicitation registrations, and compliance.' },
      { icon: 'CheckCircle2', title: 'Governance Policies', desc: 'Conflict of interest policy, document retention policy, and required governance procedures.' },
      { icon: 'Lock', title: 'Ongoing Compliance', desc: 'Support with Form 990 requirements, state filings, and maintaining exempt status.' }
    ],
    pricing: [
      {
        name: 'State Formation',
        price: '$999',
        description: 'Non-profit incorporation',
        features: [
          'Articles of Incorporation',
          'State Filing',
          'IRS-Compliant Charter',
          'Bylaws',
          'EIN Application',
          'Initial Board Meeting'
        ]
      },
      {
        name: '501(c)(3) Package',
        price: '$2,999',
        description: 'Federal tax exemption',
        popular: true,
        features: [
          'Everything in State',
          'Form 1023-EZ or 1023',
          'IRS Application',
          'Governance Policies',
          'State Tax Exemption',
          'Application Support'
        ]
      },
      {
        name: 'Complete Nonprofit',
        price: '$4,999',
        description: 'Full formation & compliance',
        features: [
          'Everything in 501(c)(3)',
          'Charitable Solicitation',
          'Multi-State Registration',
          'First Year Form 990',
          'Ongoing Compliance Support',
          'Board Training'
        ]
      }
    ],
    process: [
      {
        title: 'Mission & Structure',
        description: 'Define charitable mission, establish board of directors, draft IRS-compliant articles and bylaws with required provisions.'
      },
      {
        title: 'State & Federal Filing',
        description: 'Incorporate with state, obtain EIN, prepare and file Form 1023/1023-EZ with IRS, apply for state tax exemptions.'
      },
      {
        title: 'Compliance Setup',
        description: 'Establish governance policies, set up accounting, register for charitable solicitation, provide ongoing compliance support.'
      }
    ]
  }
};
